export let TIMEOUT = window.timeout ? window.timeout : 600000
